import React from 'react'
import { SimilarProductCard } from './SimilarProductCard'
import { ProductRes } from '../../../types/productType'

interface SimilarProduct{
  similarProduct: ProductRes[]
}
export const SimilarProduct :React.FC<SimilarProduct> = ({similarProduct}) => {
  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 gap-y-8'>
        {
            similarProduct.map((item,index)=><SimilarProductCard product={item} key={index}/>)
        }
    </div>
  )
}
